import React, { Component } from 'react';
import TextField from '../util/textfield/TextField';
import Field from '../util/field/Field';
import Loading from '../util/loading/Loading';
import MenuDriveAPI from '../../services/MenuDrive';
import EmpresasAPI from '../../services/CaffenioEmpresas/Empresas';
import ErrorMessages from '../../util/validation-error-messages';
import ExpresionesRegulares from '../../util/expresiones-regulares';
import { Formik } from 'formik';
import * as Yup from 'yup';
import lodash from 'lodash';
import Select from 'react-select';


class MenuForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            menu: {
                ...this.props.menu,
                IdSegmento: null 
            },
            esAdmin: this.props.esAdmin,
            isEditing: false,
            isLoading: false,
            listaSegmentos: null,
            listaBaseMenu: [],
            listaBaseMenuSegmentada: []
        }
    }    

    componentDidMount(){
        let listaSegmentosAux = [];
        let listaBaseMenuAux = [];
        EmpresasAPI.getAllSegments()
        .then(response => {
            listaSegmentosAux = response.data;
            return MenuDriveAPI.getMenusWithSegmentation();
        })
        .then(response => {
            listaBaseMenuAux = response.data;

            // Si es edición, se asigna el segmento seleccionado
            const segmentoSeleccionado = this.props.menu && this.props.menu.IdSegmento
            ? listaSegmentosAux.find(s => s.SegmentId === this.props.menu.IdSegmento)
            : null;

            this.setState({
                listaSegmentos: listaSegmentosAux,
                listaBaseMenu: listaBaseMenuAux,
                isLoading: false,
                menu: {
                    ...this.state.menu,
                    IdSegmento: segmentoSeleccionado || null
                }
            });

            // Si ya tenía segmento, filtra también los menús base
            if (segmentoSeleccionado) {
                this.handleSegmentosInput(segmentoSeleccionado);
            }
        })
    }

    handleSegmentosInput(value){
        let menus = this.state.listaBaseMenu.filter(menu => menu.IdSegmento === value.SegmentId)
        this.setState({ listaBaseMenuSegmentada: menus });
    }

    VALIDATION_SCHEMA = Yup.object({
        Description: Yup.string()
            .trim()
            .matches(ExpresionesRegulares.AlfanumericoConCaracteres, { message: ErrorMessages.AlfanumericoConCaracteresError })
            .min(2, "Nombre debe tener más de 2 caracteres.")
            .max(50, "Ha excedido el límite de 50 caracteres.")
            .required("Campo Descripción es requerido.")
            .test("validate-name", "La Descripción ya existe, favor de ingresar otro.", (value) => {
                let isValid = true;
                let name = value ? value.toLowerCase().trim() : "";
                if (this.props.menus.some(u => u.Description.toLowerCase().trim() === name && u.MenuId !== this.state.menu.MenuId)) {
                    isValid = false;
                }
                return isValid;
            }),
        IdSegmento: Yup.object().required("Segmento es requerido.").nullable(),
        BaseOn: Yup.object().nullable(),
        Active: Yup.bool(),

    });

    render() {
        return (

            <Formik
            initialValues={this.state.menu}
            validationSchema={this.VALIDATION_SCHEMA}
            enableReinitialize={true}
            onSubmit={(values) => {
                let formatValues = { ...values }
                formatValues.MenuId = this.state.menu.MenuId === null ? 0 : this.state.menu.MenuId;
                formatValues.Description = formatValues.Description.trim();
                formatValues.BaseMenuId =  values.BaseOn ? values.BaseOn.MenuId : 0;
                formatValues.IdSegmento = values.IdSegmento ? values.IdSegmento.SegmentId : 0;
                this.props.save(formatValues)
            }}
        >
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, setFieldError }) => (
                <form onSubmit={handleSubmit} id={"frmListaPrecios"}>
                    <Field

                        isHorizontal
                        hasError={errors.Description && touched.Description}
                        msgError={errors.Description && touched.Description ? errors.Description : ""}
                        showLeftSpaces={true}
                        childInfo={values.Description && !errors.Description
                            ? `Te quedan ${50 - values.Description.trim().length} caracteres para la descripción.`
                            : ""}
                    >
                        <TextField
                            id="MenuId"
                            autoFocus={true}
                            required
                            maxLength="50"
                            label="Descripción"
                            name="Description"
                            value={values.Description}
                            placeholder={"Ingrese descripción del menú"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={!this.props.esAdmin}
                        />
                    </Field>
                    {this.state.menu.MenuId === null && (
                        <>
                            <br />

                            <Field isHorizontal
                                hasError={errors.IdSegmento && touched.IdSegmento}
                                msgError={errors.IdSegmento && touched.IdSegmento ? errors.IdSegmento : ""}
                            >
                                <div className="column is-2">
                                    <label className="label">Segmento</label>
                                </div>
                                <div className="column is-10">
                                    <Select
                                        placeholder={"Seleccione un segmento"}
                                        name={"IdSegmento"}
                                        value={values.IdSegmento || null}
                                        onChange={value => {
                                            setFieldValue('IdSegmento', value || null);
                                            this.handleSegmentosInput(value);
                                        }}
                                        onBlur={() => setFieldTouched('IdSegmento', true)}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={this.state.listaSegmentos || []}
                                        getOptionLabel={(segmento) => segmento.Name}
                                        getOptionValue={(segmento) => segmento.SegmentId}
                                        isClearable
                                    />
                                </div>
                            </Field>

                            <br />
                        
                            <Field
                                isHorizontal
                                showTooltip={true}
                                textTooltip={"Selecciona si quieres las mismas recetas en nuevo menú."}>
                                <div className="column is-2">
                                    <label className="label">Basar Menú en</label>
                                </div>
                                <div className="column is-10">
                                    <Select
                                        id={"ddlBaseOn"}
                                        placeholder={"Seleccionar..."}
                                        name={"BaseOn"}
                                        value={values.BaseOn}
                                        onChange={(val) => {
                                            setFieldValue('BaseOn', val);
                                        }}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={lodash.sortBy(this.state.listaBaseMenuSegmentada, [ts => ts.Description.toLowerCase()], ['asc'])}
                                        getOptionLabel={(BaseOn) => BaseOn.Description}
                                        getOptionValue={(BaseOn) => BaseOn.MenuId}
                                    />
                                </div>
                            </Field>
                        </>
                    )}

                    <br />
                    <Field label="Activo" isHorizontal>
                        <input
                            id="chkActivoLista"
                            type="checkbox"
                            name="activo"
                            className="switch"
                            checked={values.Active}
                            onChange={() => { }}
                        />
                        <label htmlFor="iva" onClick={(e) => {
                            e.stopPropagation();
                            setFieldValue("Active", !values.Active)
                        }} />
                    </Field>
                    <br />
                    <div className="has-text-right buttons-modal">
                        <div className="column">
                            <button
                                type="submit"
                                className="button is-success"
                            >
                                Guardar
                    </button>
                        </div>
                    </div>
                    <Loading isFullscreen={true} isLoading={this.state.isLoading} width='100px' height='100px' />
                </form>
            )}
        </Formik>
        );
    }
}

MenuForm.defaultProps = {
    isEditing: false,
    isLoading: false,
    menu: {
        MenuId: null,
        Description: "",
        Active: false,
        IdSegmento: null 
    }
}

export default MenuForm;
